import R from 'ramda';

export default function AccountController($location,$state, $rootScope, LeadService) {
  this.save = function() {
    var contact = {
      firstName: 'John',
      lastName: 'Doe',
    };

    LeadService.save(contact).then(function() {
      $state.go('olr.mainfe.contact');
    });
  };
}




/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-account/AccountController.js
 **/